import React, { useState } from 'react';
import axios from 'axios'
import Navbar from '../../home/navbar';
import { Community_Nav } from '../community_nav'
import Footer from '../../home/footer';
import Ads_Effect from './ads_message'
import NoAdsYet from './noadsyet';
import { AdSaleCard } from './ad-sale-card';
import { AdData } from './adTestData';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Thumbs } from 'swiper';

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

const promImages = [
  {
    url: 'https://images.unsplash.com/photo-1537726235470-8504e3beef77?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8aW50ZXJpb3IlMjBkZXNpZ258ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60',
  },
  {
    url: 'https://images.unsplash.com/photo-1467803738586-46b7eb7b16a1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGJ1aWxkaW5nfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60',
  },
  {
    url: 'https://images.unsplash.com/photo-1616046229478-9901c5536a45?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8aW50ZXJpb3IlMjBkZXNpZ258ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60',
  },

];

const listings = [


  {
    url: 'https://res.cloudinary.com/daurieb51/image/upload/v1684273717/qemrqmbiahibddfqbpxy.jpg',
  },
  {
    url: 'https://res.cloudinary.com/daurieb51/image/upload/v1684276097/dxt5yv7qzxgr6ccjj3uy.jpg',
  },

  {
    url: 'https://res.cloudinary.com/daurieb51/image/upload/v1684279591/lej1kmdvz09mty9bp0qb.jpg',
  },
  {
    url: 'https://res.cloudinary.com/daurieb51/image/upload/v1686491827/scfgx9yzpizrpccuuq6s.jpg',
  },
];


function Advertisements() {

  const displayListings = () => {
   
  };
  return (

    <>
      {/* <Navbar/> */}
      <Community_Nav />

      <div className='flex flex-col 
      md:flex-row gap-4 px-5'>
        {displayListings()}

      </div>      <Footer />
    </>
  )
}

export default Advertisements
